import { SceneState } from '../../components/SceneStatemachinePlugin';
import { ActionsPlayer } from 'game/components/ActionsPlayer.js';
import { CLICK_TAP_VO, EMOTION_CLICKED_CHAIN, EMOTIONS_VO } from 'game/constants/Constants.js';
import { BtnRoundelFramed } from '../../display/BtnRoundelFramed';
import { TRACK_COMPONENTS, TRACK_EVENTS } from 'game/tracking/stats.js';
import { BACKGROUND_MUSIC } from '../../constants/Constants';

// =============================================================================================
// STATE : COIN FLIP
// =============================================================================================
export class StateScenarioEmotionFeel extends SceneState {
  constructor(scene, scenario) {
    super(scene);
    this._scenario = scenario;
  }

  startState() {
    const { names = {} } = this._scenario.tracking;
    this.game.stats.setScreenName(names.FEEL);
    this.game.stats.startComponent(TRACK_COMPONENTS.CHOOSE);
    this.game.soundController.playMusic(BACKGROUND_MUSIC.INIFIC_SCREEN);
    const { configId, emotions } = this._scenario.emotion_feel;

    this._config = this.game.cache.json.get(configId);
    // random emotion options
    const pool = Phaser.Utils.Array.Shuffle(emotions);
    this._config.emotion_options = Phaser.Utils.Array.Shuffle([
      { emotion: this._scenario.emotion_feel.emotionId, correct: true },
      pool[0],
      pool[1],
    ]);

    const sceneCharacters = this._scenario.scene_objects
      .filter((o) => o.type === 'character')
      .map((c) => {
        return this.scene.getSceneObject(c.id, c.type);
      });

    // this.focusCharacter = this.scene.getSceneObject(
    //   this._config.characters.find((c) => c.focus).id,
    //   'character'
    // );

    const opts = { game: this.game, scene: this.scene, x: 0, y: 0, config: this._config };
    this._actionsPlayer = new ActionsPlayer(opts);
    this._actionsPlayer.addSceneCharacters(sceneCharacters);
    this._actionsPlayer.once('SHOW_OPTIONS', this.positionOptions, this);
    this._actionsPlayer.once('COMPLETE_OUTRO', this.handleScenarioStateComplete, this);
    this._actionsPlayer.start();
    this._wrongAnswerCount = 0;
  }

  positionOptions() {
    this.container = this.scene.add.container();
    this.addOption(0);
  }

  startPrompt(d = 10, voId, trackStop) {
    this.endPrompt();
    this.promptTimer = this.scene.time.addEvent({
      delay: d * 1000,
      callback: () => {
        this.scene.game.vo.playChain([
          CLICK_TAP_VO(!this.scene.game.device.os.desktop),
          'NFC_2.0_36',
        ]);
        this._config.emotion_options.forEach((option, i) => {
          const btn = this.container.getByName(option.emotion);
          this.scene.tweens.add({
            targets: btn,
            scale: 1.1,
            yoyo: true,
            repeat: 1,
            duration: 100,
          });
        });
      },
    });
  }
  endPrompt() {
    if (this.promptTimer) {
      this.promptTimer.remove();
      this.promptTimer = null;
    }
  }

  addOption(index) {
    if (index < this._config.emotion_options.length) {
      const option = this._config.emotion_options[index];
      const x = 610 + 300 * index;
      const y = [300, 200, 300][index];
      const btn = new BtnRoundelFramed(this.scene, x, y, {
        thumbSheet: 'emotion_assets',
        thumbKey: `emotion_${option.emotion.toLowerCase()}`,
        active: true,
        enabled: false,
        hoverVO: EMOTIONS_VO[option.emotion],
      });
      btn.name = option.emotion;
      btn.correct = option.correct;
      btn.basePosition = { x, y };

      this.scene.tweens.add({
        targets: btn,
        scale: { from: 0, to: 1 },
        duration: 150,
        ease: Phaser.Math.Easing.Back.Out,
      });
      this.scene.game.soundController.playSFX('sfx', 'choice-bubble');

      this.container.add([btn]);
      const voId = EMOTIONS_VO[option.emotion];
      this.scene.game.vo.play(voId, {
        onComplete: () => {
          this.addOption(index + 1);
        },
      });
    } else this.activateOptions();
  }

  activateOptions() {
    this.scene.game.vo.playChain([CLICK_TAP_VO(!this.scene.game.device.os.desktop), 'NFC_2.0_36'], {
      onComplete: () => {
        this._config.emotion_options.forEach((option, i) => {
          const btn = this.container.getByName(option.emotion);
          btn.enable();
          btn.on('click', () => this.handleEmotionClicked(btn), this);
        });
        this.startPrompt();
      },
    });
  }

  deactivateOptions() {
    this._config.emotion_options.forEach((option, i) => {
      const btn = this.container.getByName(option.emotion);
      btn.disable();
      btn.removeAllListeners('click');
    });
  }

  scaleOtherOptions(keep) {
    this._config.emotion_options.forEach((option, i) => {
      if (option.emotion !== keep) {
        const btn = this.container.getByName(option.emotion);
        this.scene.tweens.add({
          targets: btn,
          scale: 0,
          duration: 100,
          onComplete: () => (btn.visible = false),
        });
      }
    });
  }

  handleSecondWrongChoice() {
    this._config.emotion_options.forEach((option, i) => {
      const btn = this.container.getByName(option.emotion);
      btn.correct ? (btn.scale = btn.scale * 1.1) : (btn.scale = btn.scale * 0.9);
    });
  }

  handleEmotionClicked(btn) {
    const chain = EMOTION_CLICKED_CHAIN[this._scenario.id];
    const trackingOptions = {
      questionAsked: 'Feelings Choice',
      questionNumber: 1,
      playerAnswer: btn.name.toLowerCase(),
    };
    if (btn.correct) {
      this.game.stats.track(TRACK_EVENTS.GAME_QUESTION_CA, trackingOptions);
      this.scene.game.soundController.playSFX('sfx', 'sfx_correct');
      this.deactivateOptions();
      this.endPrompt();

      this.scaleOtherOptions(btn.name);
      this._actionsPlayer.handleRunActionComplete('ev1');
    } else {
      this.game.stats.track(TRACK_EVENTS.GAME_QUESTION_WA, trackingOptions);
      this.scene.game.soundController.playSFX('sfx', 'sfx_incorrect');
      this.game.vo.playChain([chain[0], EMOTIONS_VO[btn.name], chain[1]]);
      btn.disable();
      btn.removeAllListeners('click');
      btn.alpha = 0.5;
      this.scene.tweens.killTweensOf(btn);
      this.scene.tweens.add({
        targets: btn,
        x: { from: btn.basePosition.x - 5, to: btn.basePosition.x + 5 },
        repeat: 2,
        yoyo: true,
        duration: 50,
        onComplete: () => btn.setPosition(btn.basePosition.x, btn.basePosition.y),
      });
      if (this._wrongAnswerCount >= 1) {
        this.handleSecondWrongChoice();
      }
      this._wrongAnswerCount++;
    }
  }

  handleScenarioStateComplete() {
    this.emit('state_complete');
  }

  onScenePaused() {}

  onSceneResumed() {}

  onSceneUpdate(time, delta) {}

  endState() {
    this.endPrompt();
    this.game.stats.completeComponent(TRACK_COMPONENTS.CHOOSE);
    if (this._actionsPlayer) {
      this._actionsPlayer.destroy();
      this._actionsPlayer = null;
    }
    if (this.container) {
      this.container.destroy();
      this.container = null;
    }
    if (this._timer) {
      this._timer.destroy();
      this._timer = null;
    }
  }
}
